export function getActionMainButtonStyle(theme) {
    return {
        flexContainer: {
            borderRadius: "4px",
            maxWidth: "none",
            width: "100%",
        },
        root: Object.assign({ border: "solid 1px", borderRadius: "3px", height: "auto", justifyContent: "center", margin: "0px 0px 0px 0px", padding: "0px 0px 0px 0px", verticalAlignment: "center", width: "100%" }, theme.customSemanticElevations.control),
        rootPressed: Object.assign({}, theme.customSemanticElevations.controlPressed),
    };
}
export function getActionMainStackStyle(theme) {
    return {
        root: Object.assign({ ".flexContainer": {
                borderRadius: "4px",
                maxWidth: "none",
                width: "100%",
            }, border: "solid 1px transparent", borderRadius: "3px", height: "auto", justifyContent: "center", margin: "0px 0px 0px 0px", padding: "0px 0px 0px 0px", verticalAlignment: "center", width: "100%" }, theme.customSemanticElevations.layer),
    };
}
export function getActionTitleStyles(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textPrimary,
            fontSize: "14",
            fontWeight: "400",
            lineheight: "20px",
            maxWidth: "332px",
            textAlign: "left",
        }
    };
}
export function getActionDescriptionStyles(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textSecondary,
            fontSize: "12",
            fontWeight: "400",
            lineheight: "16px",
            maxWidth: "332px",
            textAlign: "left",
        }
    };
}
export function getActionInfoDescriptionStyles(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textSecondary,
            fontSize: "12",
            fontWeight: "400",
            textAlign: "left",
        }
    };
}
export function getIconStackStyle(isMultiLine, isSubElement) {
    return {
        root: {
            justifyContent: "center",
            marginBottom: isMultiLine ? "23px" : "13px",
            marginLeft: isSubElement ? "64px" : "22px",
            marginRight: isSubElement ? "8px" : "22px",
            marginTop: isMultiLine ? "24px" : "14px",
            minHeight: "20px",
            minWidth: "20px",
            verticalAlignment: "center",
        }
    };
}
export function getImageIconStyle() {
    return {
        root: {
            height: "20px",
            minHeight: "20px",
            minWidth: "20px",
            width: "20px",
        }
    };
}
export function getIconStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textPrimary,
            fontSize: "20px",
        },
    };
}
export function getContentAreaStackStyle(theme, isMultiLine) {
    return {
        root: {
            alignItems: "flex-start",
            flexFlow: "column",
            justifyContent: "center",
            margin: "10px 0px 13px 0px",
            minHeight: isMultiLine ? "52px" : "32px",
            width: "100%",
        }
    };
}
export function getActionIconStackStyle(isMultiLine) {
    return {
        root: {
            margin: isMultiLine ? "25px 16px 26px 16px" : "15px 16px 16px 16px",
            padding: "0px 0px 0px 0px",
            verticalAlignment: "center",
        }
    };
}
export function getActionIconStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textPrimary,
            fontSize: "16px",
            minHeight: "16px",
            minWidth: "16px",
        },
    };
}
export function getToggleStyle(theme) {
    return {
        pill: Object.assign({}, theme.customSemanticElevations.control),
        root: {
            alignItems: "center",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            margin: "0px 0px 0px 0px",
        },
    };
}
export function getActionInfoContentStyles(theme, isMultiLine) {
    return {
        root: {
            alignItems: "flex-start",
            flexFlow: "column",
            justifyContent: "center",
            margin: "10px 20px 13px 20px",
            minHeight: isMultiLine ? "52px" : "32px",
            width: "100%",
        }
    };
}
